<template>
  <div class="flowStaffPage" v-if="basedata.workflowCode">
    <p class="tit">流程图</p>

    <div
      class="flowMain"
      v-if="basedata.verifyStatus == 'doing' || basedata.verifyStatus == 'pending'"
    >
      <p class="fbt">当前审批人：</p>
      <ul class="clearfix">
        <!-- <li class="end">
          开始
          <span> >> </span>
        </li>
        
        <li v-for="(item,index) in printWorkflowList" :key="index"  class="end" >
          {{item.realName}}
          <span> >> </span>
        </li>-->
        <li class="curruntName">{{nextManName}}</li>
        <!-- <li v-if="basedata.verifyStatus=='pass' ||  basedata.verifyStatus =='deny'"  class="end"> 结束</li> -->
      </ul>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import newApi from "lodash";
export default {
  name: "flowStaff",
  data() {
    return {
      printWorkflowList: [],
      basedata: "",
      nextManName: "" //当前审核人名称
    };
  },
  props: {
    applicantData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  mounted() {
    if (this.applicantData && this.applicantData.workflowCode) {
      console.log("审批人列表==" + JSON.stringify(this.applicantData));
      this.basedata = this.applicantData;
      this.getList();
      if (
        this.basedata.verifyStatus == "pending" ||
        this.basedata.verifyStatus == "doing"
      ) {
        this.nextFlowMan();
      }
    }
  },
  methods: {
    getList() {
      let _this = this;
      _this.$api.flowPath.flow
        .getPrintWorkflowList({
          workflowCode: _this.basedata.workflowCode
        })
        .then(res => {
          //查询流程操作记录-陈国贵
          if (res.code == "1" && res.data != null) {
            _this.printWorkflowList = res.data;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    nextFlowMan() {
      let _this = this;
      _this.$api.flowPath.flow
        .getAuditUser(_this.basedata.workflowCode, _this.basedata.verifyStatus)
        .then(res => {
          //查询流程操作记录-陈国贵
          if (res.code == "1" && res.data != null) {
            _this.nextManName = res.data.replace(/,/g, " || ");
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  watch: {
    applicantData: {
      handler: function(val) {
        if (val && val.workflowCode) {
          this.basedata = newApi.assign({}, this.basedata, val);
          if (
            this.basedata.verifyStatus == "pending" ||
            this.basedata.verifyStatus == "doing"
          ) {
            this.nextFlowMan();
          }
          this.getList();
        }
      },
      deep: true
    }
  }
};
</script>
<style lang="less">
.flowStaffPage {
  background-color: #fff;
  .tit {
    position: relative;
    padding: 0 16px 0 25px;
    font-size: 15px;
    height: 45px;
    line-height: 45px;
    position: relative;
    color: #2581d6;
    font-weight: 700;
    border-bottom: 1px solid #e0e0e0;
  }
  .tit:before {
    content: "";
    position: absolute;
    width: 5px;
    height: 21px;
    background: #2581d6;
    top: 12px;
    left: 16px;
  }
  .flowMain {
    margin-top: 10px;
    width: 100%;
    padding: 0 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #f6f6f6;
    .fbt {
      font-size: 14px;
      font: #333;
      margin-bottom: 8px;
    }
    li:first-child {
      margin-left: 2em;
    }
    li {
      font-size: 14px;
      color: #666;
      line-height: 18px;
      float: left;
      span {
        display: inline-block;
        margin: 0 5px;
        font-size: 14px;
      }
    }
    li.end {
      color: rgb(7, 193, 96);
    }
    li.curruntName {
      font-size: 16px;
      font-weight: 600;
    }
  }
}
</style>